<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-blue">
        <img src="/static/logo.png" class="navbar-brand bg-orange" href="#"></img>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item active">
                    <router-link class="nav-link text-white" to="/">
                        <i class="fa fa-home"></i> Inicio <span class="sr-only">(current)</span></router-link>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Aranceles y Protocolos 
                    </a>
                    <div class="dropdown-menu bg-blue" aria-labelledby="navbarDropdown">
                        <router-link class="dropdown-item text-white" to="/protocols">Protocolos</router-link>
                        <router-link class="dropdown-item text-white" to="/aranceles">Aranceles</router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-white" to="/supervisors">Odontólogos Tratantes</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-white" to="/benefists">Beneficios Codelco</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-white" to="/downloads">Descargas y Links </router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-white" href="https://ingresosolicitudes.dentistacontralor.cl/">Ingreso de Solicitudes</a>
                </li>
            </ul>
        </div>
    </nav>
</template>
<script>
    import config from '../config/index.js';
export default {
    name: 'NavBarComponent',
    data() {
        return {
            posts: []
        }
    },
    created() {
        this.index();
    },
    methods: {
        index () {
            axios.get(config.urlBase+ '/api/v1/public/posts').then((res) => {
                this.posts = res.data.data;
            }).catch((err) => {
                console.error(err)
            })
        }
    }
}
</script>

<style scoped>
.bg-blue {
    background: #2B4552;
}

.bg-orange {
    background-color: #ff6c1c;
}

.navbar a:hover {
    background-color: rgb(43, 69, 82) !important;
    color: #f4a700 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/NavBarComponent.vue